import React, { useEffect, useState } from "react";
import { Avatar, Typography } from "antd";
import { FaCircleUser } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/utils/Dispatcher";
import {
  holdCall,
  resumeCall,
  setCurrentCall,
} from "../../../redux/slices/sipSlice";
import { checkIfContactSaved } from "../../../utils";
import { RootState } from "../../../redux/store";
import "./index.scss";

const { Text } = Typography;
const UserAvatarIcon = FaCircleUser as unknown as React.FC;

interface CallScreenProps {
  currentCall: {
    id: string;
    number?: string;
    info?: string;
    status: string;
    isMuted?: boolean;
    isOnHold?: boolean;
    startTime?: number;
  };
  setIsFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CallDetails: React.FC<CallScreenProps> = ({ currentCall }) => {
  const dispatch = useAppDispatch();
  const [elapsed, setElapsed] = useState(0);
  // const [isFullScreen, setIsFullScreen] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const { contacts } = useSelector((state: RootState) => state.contacts);
  const { calls, currentCallId } = useSelector((state: RootState) => state.sip);
  const onGoingCalls = Object.keys(calls);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  const handleCallClick = () => {
    const clickedCall = calls[currentCall.id];
    if (
      clickedCall.id === currentCallId ||
      !clickedCall.isOnHold ||
      !currentCallId
    )
      return;

    dispatch(holdCall(currentCallId));
    dispatch(resumeCall(clickedCall.id));
    dispatch(setCurrentCall(clickedCall.id));
  };

  useEffect(() => {
    if (!currentCall?.startTime) return;

    const tick = () => {
      const now = Date.now();
      setElapsed(Math.floor((now - currentCall.startTime!) / 1000));
    };

    tick();
    const interval = setInterval(tick, 1000);

    return () => clearInterval(interval);
  }, [currentCall?.startTime]);

  useEffect(() => {
    if (!currentCall?.info) return;
    const match = currentCall.info.match(/sip:([^@]+)/);

    if (match) {
      const phoneNumber = match[1];
      setPhoneNumber(phoneNumber);
    } else {
      setPhoneNumber(currentCall?.info);
    }
  }, [currentCall.info]);

  return (
    <div className="call-details">
      <div
        onClick={handleCallClick}
        className={`call-content ${
          onGoingCalls.length > 1 &&
          (currentCall.isOnHold ? "held-call-border" : "current-call-border")
        }`}
      >
        <Avatar size={120} icon={<UserAvatarIcon />} className="call-avatar" />

        <div className="call-info">
          <Text strong className="call-number">
            {checkIfContactSaved(phoneNumber, contacts)}
          </Text>
          <Text type="secondary" className="call-status">
            {currentCall?.isOnHold
              ? "HOLD"
              : currentCall?.status === "in-progress"
              ? "CONNECTED"
              : "CALLING"}
          </Text>
          {!currentCall.isOnHold && (
            <Text type="secondary" className="call-time">
              {currentCall?.startTime ? formatTime(elapsed) : ""}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};

export default CallDetails;
